import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  CustomerContactsState,
  GroupsForNbaTopTenByOfferAddressed,
} from "src/types/CustomerContacts";

import HeatMap from "../generic/HeatMap";

interface Props {
  customerContacts: CustomerContactsState;
}

const groupOptions: Array<{
  label: string;
  value: GroupsForNbaTopTenByOfferAddressed;
}> = [
  { label: "Kundenalter", value: "ageGroup" },
  { label: "CLV", value: "clvGroup" },
  { label: "Churn Score", value: "churnScoreGroup" },
  { label: "PLZ (Top Ten Ansprache Angebot)", value: "postcodeTopTenGroup" },
];

const HeatMapMeetingsWithPositiveOutcome: React.FC<Props> = ({
  customerContacts,
}: Props) => {
  const [chartData, setChartData] = useState<
    { value: number; refValue: number }[][]
  >([]);
  const [selectedGroup, setSelectedGroup] = useState<{
    label: string;
    value: GroupsForNbaTopTenByOfferAddressed;
  }>(groupOptions[0]);
  const handleChangeHeatMapGroupOption = (
    event: React.ChangeEvent<{
      value: GroupsForNbaTopTenByOfferAddressed;
    }>
  ) => {
    const group = groupOptions.find(
      (group) => group.value === event.target.value
    );
    if (group) {
      setSelectedGroup(group);
    }
  };
  useEffect(() => {
    const countMatrixOfferAddressed =
      customerContacts.countNbaTopTenByOfferAddressed[selectedGroup.value]
        .offerAddressed.countMatrix;
    const countMatrixOfferAccepted =
      customerContacts.countNbaTopTenByOfferAddressed[selectedGroup.value]
        .offerAccepted.countMatrix;
    const _chartData: { value: number; refValue: number }[][] = [];
    for (
      let nbaDatasetIndex = 0;
      nbaDatasetIndex < countMatrixOfferAddressed.length;
      nbaDatasetIndex++
    ) {
      _chartData.push([]);
      for (
        let groupIndex = 0;
        groupIndex < countMatrixOfferAccepted[0].length;
        groupIndex++
      ) {
        _chartData[nbaDatasetIndex].push({
          value:
            countMatrixOfferAddressed[nbaDatasetIndex][groupIndex] > 0
              ? (100 * countMatrixOfferAccepted[nbaDatasetIndex][groupIndex]) /
                countMatrixOfferAddressed[nbaDatasetIndex][groupIndex]
              : -1,
          refValue: countMatrixOfferAddressed[nbaDatasetIndex][groupIndex],
        });
      }
    }
    setChartData(_chartData);
  }, [customerContacts, selectedGroup]);

  return (
    <Grid container justify="flex-end">
      <Grid item>
        {chartData.length ? (
          <FormControl style={{ width: 300, paddingBottom: 20 }}>
            <InputLabel>Eigenschaft</InputLabel>
            <Select
              value={selectedGroup.value}
              onChange={handleChangeHeatMapGroupOption}
            >
              {groupOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <div />
        )}
      </Grid>

      <Grid item xs={12}>
        <HeatMap
          data={chartData}
          columnLabels={
            customerContacts.countNbaTopTenByOfferAddressed[selectedGroup.value]
              .offerAddressed.groups
          }
          rowLabels={
            customerContacts.countNbaTopTenByOfferAddressed[selectedGroup.value]
              .offerAddressed.nbaNames
          }
          tooltip={{
            columnGroupLabel: selectedGroup.label,
            rowGroupLabel: "Beratungsfokus",
            valueLabel: "Anteil Angebot angenommen",
            refValueLabel: "Anzahl Angebot angesprochen",
          }}
          cellHeight={40}
          rowLabelsWidth={300}
          cellValueFormatter={(value: number) =>
            value >= 0 ? `${value.toFixed(1)} %` : "n.v."
          }
          cellColor={(value: number) =>
            value < 0
              ? `rgb(200,200,200,0.5)`
              : value < 50
              ? `rgb(${220 + (20 * value) / 50}, ${150 + (60 * value) / 50}, ${
                  150 - (30 * value) / 50
                }, 1)`
              : `rgb(${240 - (50 * (value - 50)) / 50}, ${
                  210 - (0 * (value - 50)) / 50
                }, ${120 - (0 * (value - 50)) / 50}, 1)`
          }
        />
      </Grid>
    </Grid>
  );
};

export default HeatMapMeetingsWithPositiveOutcome;



// WEBPACK FOOTER //
// ./src/components/NbaEvaluation/HeatMapMeetingsWithPositiveOutcome.tsx